// @generated by protoc-gen-es v2.15.0 with parameter "target=ts"
// @generated from file pricing.proto (package pricing, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { EmptySchema, Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_empty, file_google_protobuf_timestamp, file_google_protobuf_wrappers } from "@bufbuild/protobuf/wkt";
import type { Ping } from "./ping_pb";
import { file_ping } from "./ping_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file pricing.proto.
 */
export const file_pricing: GenFile = /*@__PURE__*/
  fileDesc("Cg1wcmljaW5nLnByb3RvEgdwcmljaW5nIlkKDVByaWNlUmVzcG9uc2USIQoHTWVzc2FnZRgBIAEoCzIOLnByaWNpbmcuUHJpY2VIABIaCgRQaW5nGAIgASgLMgoucGluZy5QaW5nSABCCQoHbWVzc2FnZSLXAQoFUHJpY2USEAoIQ2xpZW50SWQYASABKAYSKwoFVmFsdWUYAiABKAsyHC5nb29nbGUucHJvdG9idWYuRG91YmxlVmFsdWUSGAoQU2VjdXJpdHlNYXJrZXRJZBgDIAEoBRIOCgZTb3VyY2UYBCABKAUSLAoIRXZhbFRpbWUYBSABKAsyGi5nb29nbGUucHJvdG9idWYuVGltZXN0YW1wEiUKCVByaWNlVHlwZRgGIAEoDjISLnByaWNpbmcuUHJpY2VUeXBlEhAKCEN1cnJlbmN5GAcgASgJKiYKCVByaWNlVHlwZRIHCgNNaWQQABIHCgNCaWQQARIHCgNBc2sQAjJPCg5QcmljaW5nU2VydmljZRI9CglTdWJzY3JpYmUSFi5nb29nbGUucHJvdG9idWYuRW1wdHkaFi5wcmljaW5nLlByaWNlUmVzcG9uc2UwAUIiqgIfUG5rbC5XZWIuU3RyZWFtc1NlcnZpY2UuUHJpY2luZ2IGcHJvdG8z", [file_google_protobuf_empty, file_google_protobuf_wrappers, file_google_protobuf_timestamp, file_ping]);

/**
 * @generated from message pricing.PriceResponse
 */
export type PriceResponse = Message<"pricing.PriceResponse"> & {
  /**
   * @generated from oneof pricing.PriceResponse.message
   */
  message: {
    /**
     * @generated from field: pricing.Price Message = 1;
     */
    value: Price;
    case: "Message";
  } | {
    /**
     * @generated from field: ping.Ping Ping = 2;
     */
    value: Ping;
    case: "Ping";
  } | { case: undefined; value?: undefined };
};

/**
 * Describes the message pricing.PriceResponse.
 * Use `create(PriceResponseSchema)` to create a new message.
 */
export const PriceResponseSchema: GenMessage<PriceResponse> = /*@__PURE__*/
  messageDesc(file_pricing, 0);

/**
 * @generated from message pricing.Price
 */
export type Price = Message<"pricing.Price"> & {
  /**
   * @generated from field: fixed64 ClientId = 1;
   */
  ClientId: bigint;

  /**
   * @generated from field: google.protobuf.DoubleValue Value = 2;
   */
  Value?: number | undefined;

  /**
   * @generated from field: int32 SecurityMarketId = 3;
   */
  SecurityMarketId: number;

  /**
   * @generated from field: int32 Source = 4;
   */
  Source: number;

  /**
   * @generated from field: google.protobuf.Timestamp EvalTime = 5;
   */
  EvalTime?: Timestamp | undefined;

  /**
   * @generated from field: pricing.PriceType PriceType = 6;
   */
  PriceType: PriceType;

  /**
   * @generated from field: string Currency = 7;
   */
  Currency: string;
};

/**
 * Describes the message pricing.Price.
 * Use `create(PriceSchema)` to create a new message.
 */
export const PriceSchema: GenMessage<Price> = /*@__PURE__*/
  messageDesc(file_pricing, 1);

/**
 * @generated from enum pricing.PriceType
 */
export enum PriceType {
  /**
   * @generated from enum value: Mid = 0;
   */
  Mid = 0,

  /**
   * @generated from enum value: Bid = 1;
   */
  Bid = 1,

  /**
   * @generated from enum value: Ask = 2;
   */
  Ask = 2,
}

/**
 * Describes the enum pricing.PriceType.
 */
export const PriceTypeSchema: GenEnum<PriceType> = /*@__PURE__*/
  enumDesc(file_pricing, 0);

/**
 * @generated from service pricing.PricingService
 */
export const PricingService: GenService<{
  /**
   * @generated from rpc pricing.PricingService.Subscribe
   */
  subscribe: {
    methodKind: "server_streaming";
    input: typeof EmptySchema;
    output: typeof PriceResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_pricing, 0);

